"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Clock = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm.6-12.273C8.6 3.326 8.242 3 7.8 3c-.442 0-.8.326-.8.727v4.364c0 .193.084.378.234.514l2.4 2.182a.858.858 0 0 0 1.132 0 .681.681 0 0 0 0-1.029L8.6 7.79V3.727z"
}));

var _default = Clock;
exports.default = _default;